import React, { useState, useEffect } from 'react'
import Spinner from './Spinner';

function Home(props) {
    //const [showHome, setShowHome] = useState(true);
    //const [showOrders, setShowOrders] = useState(false);
    const [showChat, setShowChat] = useState(false);
    //const [showPayments, setShowPayments] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [showCloseOrders, setShowCloseOrders] = useState(false);
    const [submitOrdersModal, setSubmitOrdersModal] = useState([]);
    const [orders, setOrders] = useState([]);
    const [slideSubmitModal, setSlideSubmitModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFileName, setUploadFileName] = useState();
    const [spinner, setSpinner] = useState(false);
    const [menuSpinner, setMenuSpinner] = useState(false);
    const [tempmemory, setTempmemory] = useState({menuBarItem:'Orders'});
    
    
    
    
    const fetchOrders = async (limit = '30', orderby = 'id', feild = [], search = [], page=1, status=['Vendor']) => {
		//const url='https://arobaniworks.com/api/vendor/orders?&limit=20&page=1&orderby=id&feild[]=status&search[]=created' ;
        const url=process.env.REACT_APP_BASE_URL+'/api/vendor/orders?&limit=20&page=1&orderby=id&status[]='+status[0] ;
        

		// function urlBuilder() {
		// 	const baseUrl = 'https://arobaniworks.com/api/support/orders';
		// 	const feildParam = [];
		// 	const searchParam = [];
			
		// 	for (let i = 0; i < feild.length; i++) {
		// 		if (feild.length === 1) {
		// 			feildParam.push('&feild[]=' + feild[i])
		// 		} else {
		// 			feildParam.push('&feild=' + feild[i])
		// 		}
		// 	}
		// 	for (let i = 0; i < search.length; i++) {
		// 		if (search.length === 1) {
		// 			searchParam.push('&search[]=' + search[i])
		// 		} else {
		// 			searchParam.push('&search=' + search[i])
		// 		}
		// 	}
		// 	const url = `${baseUrl}?&page=${page}&limit=${limit}&orderby=${orderby}${feild && feildParam.join("")}${search && searchParam.join("")}`;
		// 	setOrderUrl({ limit, orderby, feild, search, page });
		// 	return url;
		// }

		try {
            setMenuSpinner(true);
			// const key = localStorage.getItem("loginToken");
            
            const key = props.isTokenExpired()? props.setIsLoggedIn(false) : props.token;
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			myHeaders.append("Authorization", key);

			const requestOptions = {
				method: "GET",
				headers: myHeaders,
				redirect: "manual"
			};

			await fetch(url, requestOptions)
				.then((response) => response.json())
				.then((result) => {
					//console.log(orderUrl)
                    
					if (result.success === 0) {
						//props.updateIsLoggedIn(false);
					} else {
						const data = result.data;
						if (data.length > 0) {
							setOrders(data);
							// props.footerCounts(
							// 	{
							// 		page: result.pagination.page,
							// 		offset: result.pagination.offset,
							// 		limit: result.pagination.limit,
							// 		pageRecords: result.pagination.pageRecords,
							// 		totalRecords: result.pagination.totalRecords,
							// 		totalPages: result.pagination.totalPages
							// 	}
							// );
							
                            //props.spinner(false);
						}else{
							setOrders(data);
						}
                        setMenuSpinner(false);
						//props.spinner(false);
					}
				})

		}
		catch (error) {
            setMenuSpinner(false);
			console.log(error);
		}
	}
    

    const handleCloseOeders = async(event) => {
        event.preventDefault();
        try {
            setSpinner(true);
            const url = process.env.REACT_APP_BASE_URL+'/api/support/orders';
            //const key = localStorage.getItem("loginToken");
            const key = props.isTokenExpired()? props.setIsLoggedIn(false) : props.token;
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", key);

            const requestOptions = {
                method: "PATCH",
                headers: myHeaders,
                redirect: "manual",
                body: JSON.stringify({
                    "id":submitOrdersModal.id,
                    "scan_doc": uploadFileName,
                    "stamp_no": submitOrdersModal.stamp_no,
                    "stmp_buy_cost": submitOrdersModal.stmp_buy_cost,
                    "print_qty": submitOrdersModal.print_qty,
                    "scan_qty": submitOrdersModal.scan_qty,
                    "status": "Submitted"
                })
            };
            
            await fetch(url, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    result.success === 1?setSpinner(false):setSpinner(false) ;
                    setShowCloseOrders(false);
                    fetchOrders();
                })
                
        }
        catch (error) {console.log(error)}
        
    }
    
    const handleSubmitOrderBtn = (event) => {
        setShowCloseOrders(!showCloseOrders);
        setUploadFileName(undefined);
        setUploadProgress(0);
        setSubmitOrdersModal(orders.filter((order) => order.id == event.target.id)[0]);
        //console.log(event.target.id);
        
    }

    const onChangeHandler = (event) => {
        setSubmitOrdersModal(() => ( {...submitOrdersModal,[event.target.name]: event.target.value } ))
    }

    const shareDoc = async (image) => {
        //console.log(image)
        const response = await fetch(image);
        // here image is url/location of image
        const blob = await response.blob();
        const file = new File([blob], 'share.jpg', { type: blob.type });
        console.log(file);
        if (navigator.share) {
            await navigator.share({
                title: "title",
                text: "your text",
                url: "url to share",
                files: [file]
            })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error in sharing', error));
        } else {
            console.log(`system does not support sharing files.`);
        }
    }

    useEffect(() => {
        fetchOrders();
        
        
        if (navigator.share === undefined) {
            //   if (window.location.protocol === 'http:') {
            //     window.location.replace(window.location.href.replace(/^http:/, 'https:'));
            //   } 
        }
        return 
    }, []);

    const FileUploadHandler = (event) => {

        const file = event.target.files[0];
        //console.log(file)
        //pdf - application/pdf
        //docx - application/vnd.openxmlformats-officedocument.wordprocessingml.document
        //xlsx - application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        //jpeg - image/jpeg
        //png - image/png
        if (file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/pdf') {
            alert('Please select a DOCX or PDF file only.');
            return;
        }

        if (file.size > 5120 * 5120) {
            alert('File size should not exceed 5MB.');
            return;
        }

        const divNumber = event.target.id.split("-")[2]

        divNumber == 1 && setUploadFileName(() => (file.name))
        // //divNumber == 1 && setUploadFileName1(file.name)
        // divNumber == 2 && setFormData(() => ({ ...formData, ['fileName2']: file.name }))
        // //divNumber == 2 && setUploadFileName2(file.name)
        // divNumber == 3 && setFormData(() => ({ ...formData, ['fileName3']: file.name }))
        // //divNumber == 3 && setUploadFileName3(file.name)

        const fd = new FormData();
        fd.append('avtar', file);
        //filename = filename.replace(/[/\\?%*-:| "<>]/g, '');
        console.log(fd);
        // setUploadProgress(0.4)

        /*
        fetch('http://arobaniworks.com/api/support/upload', {
            method: 'POST',
            body: fd,
            redirect: "follow",
            headers:{
                Authorization: localStorage.getItem("loginToken")
            }
        })
        .then((res) => res.text())
        .then((result) => { console.log(result); setUploadProgress(1) })
        .catch(err => {console.log(err); setUploadProgress(0) })
        */

        async function main(inputNo) {
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    var jsonResponse = JSON.parse(xhr.responseText);
                    divNumber == 1 && setUploadFileName(() => jsonResponse.file.filename);
                    // divNumber == 2 && setFormData(() => ({ ...formData, ['fileName2']: jsonResponse.file.filename }));
                    // divNumber == 3 && setFormData(() => ({ ...formData, ['fileName3']: jsonResponse.file.filename }));

                }
            }
            const success = await new Promise((resolve) => {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        //console.log("upload progress:", event.loaded / event.total);
                        // uploadProgress.value = event.loaded / event.total;
                        inputNo == 1 && setUploadProgress(event.loaded / event.total)
                        // inputNo == 2 && setUploadProgress2(event.loaded / event.total)
                        // inputNo == 3 && setUploadProgress3(event.loaded / event.total)
                    }
                });
                xhr.open("POST", process.env.REACT_APP_BASE_URL+"/api/support/upload", true);
                // xhr.setRequestHeader("Content-Type", "application/octet-stream");
                // xhr.setRequestHeader("Authorization", localStorage.getItem("loginToken"));
                xhr.setRequestHeader("Authorization", props.isTokenExpired()?props.setIsLoggedIn(false):props.token );
                xhr.send(fd);
            })
            //console.log("SuccessIs:", success);
        }

        main(event.target.id.split("-")[2]).catch(console.error);

        //console.log('ID is - '+ event.target.id.split("-")[2] )
        //console.log(event.target.files[0].name)

        const access = {

        }
        
    }



    return (
        <>

   
            {spinner&&<Spinner />}
            <div className="root-container">
                <div className="wide-layout">
                    <div className="wide-layout__header">
                        <div className="app-header">
                            <div className="company-name">
                                Kala Coat
                                <button className="header-icon">
                                    <span onClick={() => {props.setIsLoggedIn(false);}} style={{ "color": "white", "margin": "auto" }} className="material-symbols-outlined">contract</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="wide-layout__content">
                        <div className="wide-layout__content-container">
                            <div className="container-tab">
                                <nav className="container-tab__nav">
                                    <div onClick={() => {fetchOrders(30, 'id', [], [], 1, ['Vendor']); setTempmemory({...tempmemory, menuBarItem:'Orders'}) }} className="container-tab__nav-item-wraper">
                                        <button className={tempmemory.menuBarItem==='Orders'?"container-tab__nav-item container-tab__nav-item-active":"container-tab__nav-item"}>
                                            <div className="tab-item">Orders</div>
                                        </button>
                                    </div>
                                    <div onClick={() => {fetchOrders(30, 'id', [], [], 1, ['Closed']); setTempmemory({...tempmemory, menuBarItem:'Submitted'}) }} className="container-tab__nav-item-wraper">
                                        <button className={tempmemory.menuBarItem==='Submitted'?"container-tab__nav-item container-tab__nav-item-active":"container-tab__nav-item"}>
                                            <div className="tab-item">Submitted</div>
                                        </button>
                                    </div>
                                    <div onClick={() => {fetchOrders(30, 'id', [], [], 1, ['Pickup']); setTempmemory({...tempmemory, menuBarItem:'Pickup'}) }} className="container-tab__nav-item-wraper">
                                        <button className={tempmemory.menuBarItem==='Pickup'?"container-tab__nav-item container-tab__nav-item-active":"container-tab__nav-item"}>
                                            <div className="tab-item">Pickup</div>
                                        </button>
                                    </div>
                                    <div style={{marginLeft:'auto'}} onClick={() => {fetchOrders(30, 'id', [], [], 1, ['Vendor']); setTempmemory({...tempmemory, menuBarItem:'Orders'}) }} className="container-tab__nav-item-wraper">
                                        <button style={{width:'80px',fontSize:'12px',fontStyle:'italic'}} className="container-tab__nav-item">
                                        {menuSpinner?<span className="loader"></span>:<div className="tab-item">Refresh</div>}
                                        </button>
                                    </div>
                                </nav>
                                <section className="container-tab__content"></section>
                            </div>
                            <div className="container-body">
                                <div className="container-body-view">
                                    <div className="current-page">
                                        <div className="page-content">
                                            <div className="page-list">
                                                <ul>
                                                    {
                                                        orders.map((givenOrders, i) => {
                                                            const { bdated, business_name, company_name, copies, created_at, created_by, customer_address, customer_name, date, documents, id, in_cus_name, in_cus_add, notary, certificate, order_no, cust_order_no, print_qty, scan, scan_doc, scan_qty, ship, ship_name, ship_phone, ship_address, shiplabel, stamp_no, stamp_qty, stamp_value, state, status, stmp_buy_cost, tracking_id, updated_at, updated_by, vendor, vendor_note
                                                            } = givenOrders;
                                                            
                                                            return (
                                                                <li key={i}>
                                                                    <div className="item-content">
                                                                        <div className="item-inner">
                                                                            <div className="item-inner-w-ful-relative">
                                                                                <article className="order-item">
                                                                                    <div className="order-item-flex">
                                                                                        <div className="order-item-start">
                                                                                            <div className="header-item" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

                                                                                                {/* <img alt="download_image" src="https://one.delhivery.com/assets/box-grey.c7a88e89.svg" /> */}
                                                                                                {/* <span style={{ fontSize: '2rem', color: '#1F51FF' }} className="material-symbols-outlined">Docs</span> */}
                                                                                                
                                                                                                {documents.split("/")[0]&&
                                                                                                <span className='tooltip'>
                                                                                                    <span style={documents.split("/")[0].split(".")[1]==="pdf"?{fontSize:'30px',color:'red'}:{fontSize:'30px',color:'blue'}} id="downloadFile1" className="material-symbols-outlined" onClick={() => {window.location.href = process.env.REACT_APP_BASE_URL+"/api/support/downloads/" + documents.split("/")[0] }}>file_save</span>
                                                                                                    <span className='tooltiptext'>{documents.split("/")[0]}</span>
                                                                                                </span>
                                                                                                }
                                                                                                

                                                                                                {/* <span onClick={(() => shareDoc('https://arobaniworks.com/api/support/downloads/1735571874090_329651.docx'))} style={{ marginTop: '1rem', fontSize: '1rem', display: 'inline-block' }} className="material-symbols-outlined">Share</span> */}

                                                                                                {/* <div>
                                                                            <img alt="download_image" src="https://one.delhivery.com/assets/box-grey.c7a88e89.svg" />
                                                                            </div> */}
                                                                                            </div>
                                                                                            <div className="order-item-details">
                                                                                                <div className="">
                                                                                                    <div className="">
                                                                                                        <div className="items-start-left-order">{cust_order_no}</div>
                                                                                                        <div className="items-start-left-awb"><span style={{ fontSize: '16px', paddingRight: '4px' }} className="material-symbols-outlined">Subheader</span> Stamp Paper {stamp_value} x {stamp_qty}</div>
                                                                                                        {in_cus_name!==""? <div style={{ lineHeight: '1rem' }} className="items-start-left-awb"><span style={{ fontSize: '18px', paddingRight: '4px' }} className="material-symbols-outlined">Person</span><span style={{ fontSize: '11px', fontWeight: '500', fontStyle: 'italic' }}>{in_cus_name} / {in_cus_add}</span></div> :""}
                                                                                                        {(notary===1 || bdated!=="") && <div className="items-start-left-awb"><span style={{ fontSize: '16px', paddingRight: '4px' }} className="material-symbols-outlined">gavel</span>{`${notary===1?"Notary":""} ${bdated!==""?"BD - "+bdated:""}`}</div>}
                                                                                                        {certificate===1&&<div className="items-start-left-awb"><span style={{ fontSize: '16px', paddingRight: '4px' }} className="material-symbols-outlined">play_lesson</span>With Certificate</div>}
                                                                                                        {scan===1&&<div className="items-start-left-awb"><span style={{ fontSize: '16px', paddingRight: '4px' }} className="material-symbols-outlined">document_scanner</span>Scan</div>}
                                                                                                        {ship!==0&&<div className="items-start-left-awb"><span style={ship===2?{fontSize: '16px', paddingRight: '4px',color:'red' }:{ fontSize: '16px', paddingRight: '4px'}} className="material-symbols-outlined">{(ship===1&&"delivery_truck_speed")||(ship===2&&"moped")}</span> {(ship===1&&"Standard Shipping")||(ship===2&&"Express Shipping")}</div>}
                                                                                                        {/* | 100 x 1 | Sumanto / ECTP E26/16 Phase IV Kasba Industrial Area, Kolkata 700107 | Notary | 08 Jan 2025 | With Certificate | Scan | Normal Shipping | Copies - 1 | Copy */}
                                                                                                    </div>
                                                                                                    <div className="items-start-right">{date}</div>
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>
                                                                                        <div className="order-item-border"></div>
                                                                                        <button id={id} onClick={handleSubmitOrderBtn} className="order-item-footer">{status=="Closed"?"View Order":"Submit Order"}</button>
                                                                                    </div>
                                                                                </article>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }

                                                    

                                                    
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-nav-bar">
                    <nav className="ap-tab-nav">
                        <div className="ap-tab-nav-item-wraper">
                            <button className="ap-tab-nav-item">
                                <span className="ap-tab-nav-item-utility-badge"></span>
                                <span className="material-symbols-outlined">cottage</span>
                                <div>Home</div>
                            </button>
                        </div>
                        <div className="ap-tab-nav-item-wraper">
                            <button style={{ "borderTop": "2px solid", "fontWeight": "900" }} className="ap-tab-nav-item">
                                <span className="ap-tab-nav-item-utility-badge"></span>
                                <span className="material-symbols-outlined">order_approve</span>
                                <div>Orders</div>
                            </button>
                        </div>
                        <div style={{ "width": "60px" }} className="ap-tab-nav-item-wraper" onClick={() => setShowChat(!showChat)}>
                            <button className="ap-tab-nav-item-center">
                                <span className="ap-tab-nav-item-utility-badge"></span>
                                <span className="material-symbols-outlined">local_shipping</span>
                                <div></div>
                                <div className="item-center-action-btn">
                                    <span style={{ "color": "white" }} className="material-symbols-outlined">gavel</span>
                                </div>
                            </button>
                        </div>
                        <div className="ap-tab-nav-item-wraper">
                            <button className="ap-tab-nav-item">
                                <span className="ap-tab-nav-item-utility-badge"></span>
                                <span className="material-symbols-outlined">currency_rupee</span>
                                <div>Payments</div>
                            </button>
                        </div>
                        <div className="ap-tab-nav-item-wraper" onClick={() => setShowMore(!showMore)}>
                            <button className="ap-tab-nav-item">
                                <span className="ap-tab-nav-item-utility-badge"></span>
                                <span className="material-symbols-outlined">more_horiz</span>
                                <div>More</div>
                            </button>
                        </div>
                    </nav>
                </div>
            </div>



            {showMore &&
                <div className="container-modal-more">
                    <div className="container-modal-more-content">
                        <div className="modal-more-content-header">
                            <header className="modal-more-content-header-text">More</header>
                            <button className="modal-more-content-header-close" onClick={() => {setShowMore(!showMore); setSlideSubmitModal(false);}}>
                                <span className="material-symbols-outlined">close</span>
                            </button>
                        </div>
                        <div className="container-modal-more-body">
                            <div className="container-modal-more-body-w-full">
                                <ul>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">shower</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Document Collection</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">shower</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Stamp Paper Sale</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">shower</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Notary Certificate</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">shower</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Digital Signature</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">shower</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Revenue Stamp</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">shower</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Rent Receipt</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                // <div className="container-modal-more">
                //     <div className="container-modal-more-content">
                //         <div className="modal-more-content-header">
                //             <header className="modal-more-content-header-text">More</header>
                //             <button className="modal-more-content-header-close">
                //                 <span className="material-symbols-outlined" onClick={() => setShowMore(!showMore)}>close</span>
                //             </button>
                //         </div>
                //         <div className="container-modal-more-body">
                //             <div className="container-modal-more-body-w-full">
                //                 <form className="case-closing-form">
                //                     <div className="close-form-ap-input">
                //                         <div >
                //                             <label>
                //                                 <span className="close-form-ap-label-container">
                //                                     <span className="close-form-ap-label">First Name</span>
                //                                 </span>
                //                                 <div className="close-form-ap-input-container">
                //                                     <input className="label-container-input" type="text" placeholder="Enter First Name" />
                //                                 </div>
                //                             </label>
                //                         </div>
                //                     </div>

                //                     <div className="close-form-ap-input">
                //                         <div >
                //                             <label>
                //                                 <span className="close-form-ap-label-container">
                //                                     <span className="close-form-ap-label">Last Name</span>
                //                                 </span>
                //                                 <div className="close-form-ap-input-container">
                //                                     <input className="label-container-input" type="text" placeholder="Enter Last Name" />
                //                                 </div>
                //                             </label>
                //                         </div>
                //                     </div>

                //                     <div className="close-form-ap-input">
                //                         <div >
                //                             <label>
                //                                 <span className="close-form-ap-label-container">
                //                                     <span className="close-form-ap-label">Email</span>
                //                                 </span>
                //                                 <div className="close-form-ap-input-container">
                //                                     <input className="label-container-input" type="text" placeholder="Enter Email ID" />
                //                                 </div>
                //                             </label>
                //                         </div>
                //                     </div>

                //                     <div className="close-form-ap-input">
                //                         <div >
                //                             <label>
                //                                 <span className="close-form-ap-label-container">
                //                                     <span className="close-form-ap-label">Phone Number</span>
                //                                 </span>
                //                                 <div className="close-form-ap-input-container">
                //                                     <div className="container-input-addon-leading">+91</div>
                //                                     <input className="label-container-input" type="text" placeholder="Enter Phone Number" />
                //                                 </div>
                //                             </label>
                //                         </div>
                //                     </div>

                //                     <div className="close-form-ap-input">
                //                         <div >
                //                             <label>
                //                                 <span className="close-form-ap-label-container">
                //                                     <span className="close-form-ap-label">Shipping Address Line 1</span>
                //                                 </span>
                //                                 <div className="close-form-ap-input-container">
                //                                     <input className="label-container-input" type="text" placeholder="Address Line 1" />
                //                                 </div>
                //                             </label>
                //                             <p className="label-container-info">This will be used in the invoices that you will print</p>
                //                         </div>
                //                     </div>

                //                     <div className="close-form-ap-input">
                //                         <div >
                //                             <label>
                //                                 <span className="close-form-ap-label-container">
                //                                     <span className="close-form-ap-label">Shipping Address Line 2</span>
                //                                     <div>
                //                                         <span className="close-form-ap-optional-corner-hint">Optional</span>
                //                                     </div>
                //                                 </span>
                //                                 <div className="close-form-ap-input-container">
                //                                     <input className="label-container-input" type="text" placeholder="Address Line 2" />
                //                                 </div>
                //                             </label>
                //                             <p className="label-container-info">This will be used in the invoices that you will print</p>
                //                         </div>
                //                     </div>

                //                     <div className="close-form-ap-two-in-row">

                //                         <div className="close-form-ap-two-in-row-left">
                //                             <div className="close-form-ap-input">
                //                                 <div >
                //                                     <label>
                //                                         <span className="close-form-ap-label-container">
                //                                             <span className="close-form-ap-label">First Name</span>
                //                                         </span>
                //                                         <div className="close-form-ap-input-container">
                //                                             <input className="label-container-input" type="text" placeholder="Enter First Name" />
                //                                         </div>
                //                                     </label>
                //                                 </div>
                //                             </div>


                //                         </div>

                //                         <div className="close-form-ap-two-in-row-right">
                //                             <div className="close-form-ap-input">
                //                                 <div >
                //                                     <label>
                //                                         <span className="close-form-ap-label-container">
                //                                             <span className="close-form-ap-label">Last Name</span>
                //                                         </span>
                //                                         <div className="close-form-ap-input-container">
                //                                             <input className="label-container-input" type="text" placeholder="Enter Last Name" />
                //                                         </div>
                //                                     </label>
                //                                 </div>
                //                             </div>
                //                         </div>



                //                     </div>

                //                     <div className="close-form-ap-two-in-row">

                //                         <div className="close-form-ap-two-in-row-left">
                //                             <div className="close-form-ap-input">
                //                                 <div >
                //                                     <label>
                //                                         <span className="close-form-ap-label-container">
                //                                             <span className="close-form-ap-label">First Name</span>
                //                                         </span>
                //                                         <div className="close-form-ap-input-container">
                //                                             <input className="label-container-input" type="text" placeholder="Enter First Name" />
                //                                         </div>
                //                                     </label>
                //                                 </div>
                //                             </div>


                //                         </div>

                //                         <div className="close-form-ap-two-in-row-right">
                //                             <div className="close-form-ap-input">
                //                                 <div >
                //                                     <label>
                //                                         <span className="close-form-ap-label-container">
                //                                             <span className="close-form-ap-label">Last Name</span>
                //                                         </span>
                //                                         <div className="close-form-ap-input-container">
                //                                             <input className="label-container-input" type="text" placeholder="Enter Last Name" />
                //                                         </div>
                //                                     </label>
                //                                 </div>
                //                             </div>
                //                         </div>



                //                     </div>

                //                     <fieldset className="close-form-ap-checkbox">
                //                         <label className="checkbox-container">
                //                             <div className="checkbox-container-wrapper">
                //                                 <input type="checkbox" className="checkbox-container-wrapper-input" />
                //                             </div>
                //                             <div className="checkbox-container-label">
                //                                 <span>Billing address same as the shipping address</span>
                //                             </div>
                //                         </label>
                //                     </fieldset>

                //                     <div className="close-form-ap-footer-container">
                //                         <div className="close-form-ap-footer-wrapper">
                //                             <div className="close-form-ap-footer-wrapper-action">
                //                                 <div className="close-form-ap-footer-wrapper-action-left">
                //                                     <button className="close-form-ap-footer-wrapper-action-left-button">Cancel</button>
                //                                 </div>

                //                                 <div className="close-form-ap-footer-wrapper-action-right">
                //                                     <button className="close-form-ap-footer-wrapper-action-right-button">Close Order</button>
                //                                 </div>
                //                             </div>
                //                         </div>
                //                     </div>



                //                 </form>
                //             </div>
                //         </div>
                //     </div>
                // </div>
            }


            {showChat &&
                <div className="container-modal-more">
                    <div className="container-modal-more-content">
                        <div className="modal-more-content-header">
                            <header className="modal-more-content-header-text">Chat</header>
                            <button className="modal-more-content-header-close" onClick={() => setShowChat(!showChat)}>
                                <span className="material-symbols-outlined">close</span>
                            </button>
                        </div>
                        <div className="container-modal-more-body">
                            <div className="container-modal-more-body-w-full">
                                <ul>

                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">person</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Order number 232432 scan ta same agreeemnt hobe ki ?</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">person</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">dekhe money hochey document e kichu gondogol hoyechey. Ekbar check ki kore neben ?</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">person</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">Dutoi document e same name details dwa achey tai amar doubt hochey. Khub money hoi bhul document patiye chey.</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item">
                                            <div className="modal-side-bar-item-flex">
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">person</span>
                                                </span>
                                                <span className="modal-side-bar-item-flex-heading">apni confirm kore amake janan tar por aita preocess korbo.</span>
                                            </div>
                                        </div>
                                    </li>


                                    <li>
                                        <div className="modal-side-bar-item support-agent ">
                                            <div className="modal-side-bar-item-flex ">
                                                <span className="modal-side-bar-item-flex-heading">Ha dada deklam, amar o money hochey ki bhul document patiye chey. Ami oder satey khoth bole dekchi ki boley.</span>
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">support_agent</span>
                                                </span>

                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="modal-side-bar-item support-agent ">
                                            <div className="modal-side-bar-item-flex ">
                                                <span className="modal-side-bar-item-flex-heading">Ami confirm korlam customer bhul document patiye chey. Ami order ta ferot niye nichi ar customer er document correction hoye gale abar apney order ta patiye debo. Thank you. Money hoi na aj hobe khub sombhoboto kal hi correction kore apnake patate parbo.</span>
                                                <span className="modal-side-bar-item-flex-icon">
                                                    <span className="material-symbols-outlined">support_agent</span>
                                                </span>

                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div style={{ "display": "flex", "justifyContent": "space-evenly", "width": "100%", "padding": "20px 0px" }} className="container-modal-more-footer-type-text">
                            <div style={{ "width": "100%", "marginLeft": "10px" }}>
                                <input type="text" placeholder="Message" style={{ "width": "100%", "height": "3rem", "padding": "5px", "outline": "none", "paddingLeft": "5px", "borderRadius": "10px", "border": "1px solid", "fontSize": "18px" }} />
                            </div>
                            <div style={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }}>
                                <button style={{ "width": "4rem", "height": "2rem", "borderRadius": "5px", "margin": "0 10px", "backgroundColor": "white", "border": "1px solid" }}>Send</button>
                            </div>

                        </div>
                    </div>
                </div>
            }

            {showCloseOrders &&

                <div className="container-modal-more">
                    <div className="container-modal-more-content">
                        <div className="modal-more-content-header">
                            <header className="modal-more-content-header-text">Order # {submitOrdersModal.cust_order_no}</header>
                            <button className="modal-more-content-header-close">
                                <span onClick={() => {setShowCloseOrders(!showCloseOrders); setUploadFileName(undefined); setUploadProgress(0)}} className="material-symbols-outlined">close</span>
                            </button>
                        </div>
                        <div className="container-modal-more-body">
                            <div className="container-modal-more-body-w-full">
                                <form className="case-closing-form" onSubmit={handleCloseOeders}>
                                    
                                    <div className='file-upload-container'>
                                        <div className='file-upload-col'>
                                            <label style={{padding:'5px 0'}} className='tooltip'>{uploadFileName===undefined?submitOrdersModal.scan_doc:uploadFileName}<div className='tooltiptext'>{uploadFileName}</div></label>
                                            {submitOrdersModal.status==="Closed"?
                                            submitOrdersModal.scan_doc!==""?
                                            <label onClick={() => {window.location.href = process.env.REACT_APP_BASE_URL+"/api/support/downloads/" + submitOrdersModal.scan_doc }} htmlFor="file-upload-1" className="custom-file-upload" style={{width:'76px'}}>Download</label>:"" :
                                            <label htmlFor="file-upload-1" className="custom-file-upload">Upload</label>}
                                            {submitOrdersModal.status!=="Closed"&&<input id="file-upload-1" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={(event) => FileUploadHandler(event)} />}
                                            {/* <span>Uploading...</span> */}
                                            <progress style={{width:'90%',padding:'10px 0'}} value={uploadProgress} />
                                        </div>
                                    </div>
                                    
                                    <div className="close-form-ap-two-in-row">
                                        <div className="close-form-ap-two-in-row-left">
                                            <div className="close-form-ap-input">
                                                <div >
                                                    <label>
                                                        <span className="close-form-ap-label-container">
                                                            <span className="close-form-ap-label">Stamp Number</span>
                                                        </span>
                                                        <div className="close-form-ap-input-container">
                                                            <input name='stamp_no' value={submitOrdersModal.stamp_no} onChange={onChangeHandler} className="label-container-input" type="text" placeholder="Stamp Number" />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="close-form-ap-two-in-row-right">
                                            <div className="close-form-ap-input">
                                                <div >
                                                    <label>
                                                        <span className="close-form-ap-label-container">
                                                            <span className="close-form-ap-label">Stamp Buy Cost</span>
                                                        </span>
                                                        <div className="close-form-ap-input-container">
                                                            <input name='stmp_buy_cost' value={submitOrdersModal.stmp_buy_cost===0?"":submitOrdersModal.stmp_buy_cost} onChange={onChangeHandler} className="label-container-input" type="number" placeholder="Stamp Buy Cost" />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="close-form-ap-two-in-row">
                                        <div className="close-form-ap-two-in-row-left">
                                            <div className="close-form-ap-input">
                                                <div >
                                                    <label>
                                                        <span className="close-form-ap-label-container">
                                                            <span className="close-form-ap-label">Print Qty</span>
                                                        </span>
                                                        <div className="close-form-ap-input-container">
                                                            <input name='print_qty' value={submitOrdersModal.print_qty===0?"":submitOrdersModal.print_qty} onChange={onChangeHandler} className="label-container-input" type="number" placeholder="Print Quantity" />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="close-form-ap-two-in-row-right">
                                            <div className="close-form-ap-input">
                                                <div >
                                                    <label>
                                                        <span className="close-form-ap-label-container">
                                                            <span className="close-form-ap-label">Scan Qty</span>
                                                        </span>
                                                        <div className="close-form-ap-input-container">
                                                            <input name='scan_qty' value={submitOrdersModal.scan_qty===0?"":submitOrdersModal.scan_qty} onChange={onChangeHandler} className="label-container-input" type="number" placeholder="Scan Quantity" />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                    

                                    {/*<div className="close-form-ap-input">
                                <div >
                                    <label>
                                        <span className="close-form-ap-label-container">
                                            <span className="close-form-ap-label">Scan Quantity</span>
                                        </span>
                                        <div className="close-form-ap-input-container">
                                            <input className="label-container-input" type="text" placeholder="Scan Quantity" />
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div className="close-form-ap-input">
                                <div >
                                    <label>
                                        <span className="close-form-ap-label-container">
                                            <span className="close-form-ap-label">Print Quantity</span>
                                        </span>
                                        <div className="close-form-ap-input-container">
                                            <input className="label-container-input" type="text" placeholder="Print Quantity" />
                                        </div>
                                    </label>
                                </div>
                            </div>

                             <div className="close-form-ap-input">
                                <div >
                                    <label>
                                        <span className="close-form-ap-label-container">
                                            <span className="close-form-ap-label">Email</span>
                                        </span>
                                        <div className="close-form-ap-input-container">
                                            <input className="label-container-input" type="text" placeholder="Enter Email ID" />
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div className="close-form-ap-input">
                                <div >
                                    <label>
                                        <span className="close-form-ap-label-container">
                                            <span className="close-form-ap-label">Phone Number</span>
                                        </span>
                                        <div className="close-form-ap-input-container">
                                            <div className="container-input-addon-leading">+91</div>
                                            <input className="label-container-input" type="text" placeholder="Enter Phone Number" />
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div className="close-form-ap-input">
                                <div >
                                    <label>
                                        <span className="close-form-ap-label-container">
                                            <span className="close-form-ap-label">Shipping Address Line 1</span>
                                        </span>
                                        <div className="close-form-ap-input-container">
                                            <input className="label-container-input" type="text" placeholder="Address Line 1" />
                                        </div>
                                    </label>
                                    <p className="label-container-info">This will be used in the invoices that you will print</p>
                                </div>
                            </div>

                            <div className="close-form-ap-input">
                                <div >
                                    <label>
                                        <span className="close-form-ap-label-container">
                                            <span className="close-form-ap-label">Shipping Address Line 2</span>
                                            <div>
                                                <span className="close-form-ap-optional-corner-hint">Optional</span>
                                            </div>
                                        </span>
                                        <div className="close-form-ap-input-container">
                                            <input className="label-container-input" type="text" placeholder="Address Line 2" />
                                        </div>
                                    </label>
                                    <p className="label-container-info">This will be used in the invoices that you will print</p>
                                </div>
                            </div>

                            <div className="close-form-ap-two-in-row">
                                
                                <div className="close-form-ap-two-in-row-left">
                                    <div className="close-form-ap-input">
                                        <div >
                                            <label>
                                                <span className="close-form-ap-label-container">
                                                    <span className="close-form-ap-label">First Name</span>
                                                </span>
                                                <div className="close-form-ap-input-container">
                                                    <input className="label-container-input" type="text" placeholder="Enter First Name" />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    
                                    
                                </div>

                                <div className="close-form-ap-two-in-row-right">
                                    <div className="close-form-ap-input">
                                        <div >
                                            <label>
                                                <span className="close-form-ap-label-container">
                                                    <span className="close-form-ap-label">Last Name</span>
                                                </span>
                                                <div className="close-form-ap-input-container">
                                                    <input className="label-container-input" type="text" placeholder="Enter Last Name" />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            
                                
                                
                            </div>

                            <div className="close-form-ap-two-in-row">
                                
                                <div className="close-form-ap-two-in-row-left">
                                    <div className="close-form-ap-input">
                                        <div >
                                            <label>
                                                <span className="close-form-ap-label-container">
                                                    <span className="close-form-ap-label">First Name</span>
                                                </span>
                                                <div className="close-form-ap-input-container">
                                                    <input className="label-container-input" type="text" placeholder="Enter First Name" />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    
                                    
                                </div>

                                <div className="close-form-ap-two-in-row-right">
                                    <div className="close-form-ap-input">
                                        <div >
                                            <label>
                                                <span className="close-form-ap-label-container">
                                                    <span className="close-form-ap-label">Last Name</span>
                                                </span>
                                                <div className="close-form-ap-input-container">
                                                    <input className="label-container-input" type="text" placeholder="Enter Last Name" />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            
                                
                                
                            </div>

                            <fieldset className="close-form-ap-checkbox">
                                <label className="checkbox-container">
                                    <div className="checkbox-container-wrapper">
                                        <input type="checkbox" className="checkbox-container-wrapper-input" />
                                    </div>
                                    <div className="checkbox-container-label">
                                        <span>Billing address same as the shipping address</span>
                                    </div>
                                </label>
                            </fieldset> */}

                                    <div className="close-form-ap-footer-container">
                                        <div className="close-form-ap-footer-wrapper">
                                            <div className="close-form-ap-footer-wrapper-action">
                                                <div className="close-form-ap-footer-wrapper-action-left">
                                                    <button type="button" onClick={() => {setShowCloseOrders(!showCloseOrders); setUploadFileName(undefined); setUploadProgress(0) }} className="close-form-ap-footer-wrapper-action-left-button">Cancel</button>
                                                </div>

                                                <div className="close-form-ap-footer-wrapper-action-right">
                                                    <button type="submit" disabled={submitOrdersModal.status==="Closed" || submitOrdersModal.status==="Pickup"} style={submitOrdersModal.status=="Closed" || submitOrdersModal.status==="Pickup"?{display:'none'}:{}} className="close-form-ap-footer-wrapper-action-right-button">Submit Order</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </form>
                            </div>
                        </div>
                    </div>
                </div>


            }

        </>

    )
}

export default Home
